import axios from '@/api/axios'

const createReporting = (reporting) => {
  return axios.post('/applicationsReporting', reporting)
}

const getReportingByParams = (params) => {
  return axios
    .get(`/applicationsReporting/listForAdmin${params}`)
    .then((response) => response.data)
}

const getReporting = (id) => {
  return axios.get(`/applicationsReporting/${id}/info`)
}

export default {
  createReporting,
  getReportingByParams,
  getReporting,
}
